/*
 * @Author: yejianfei
 * @Date: 2023-04-19 23:29:13
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-22 22:20:29
 * @Description:
 * @Developer:
 */
import React, { useEffect, useState } from 'react';
import { List, Select, Tag } from 'antd';
import Text from '../Text';
import View from '../View';
import Api from '../../api';
import './APITagListSearchSelect.scss';
const api = Api();
export default function APITagListSearchSelect(props) {
    var _a, _b;
    const [tags, setTags] = useState([]);
    const [selected, setSelected] = useState('');
    const [options, setOptions] = useState([]);
    const getTagValue = (item) => item[props.tagFieldNames ? (props.tagFieldNames.id || 'id') : 'id'];
    const getTagText = (item) => item[props.tagFieldNames ? (props.tagFieldNames.text || 'text') : 'text'];
    useEffect(() => {
        typeof (props.tags) === 'string'
            ? api.get(props.tags).then((data) => setTags(data))
            : setTags(props.tags || []);
    }, []);
    return (React.createElement(View, { className: 'ant-list-input' },
        React.createElement(Select, { options: options, showSearch: true, fieldNames: {
                value: ((_a = props.tagFieldNames) === null || _a === void 0 ? void 0 : _a.id) || 'id',
                label: ((_b = props.tagFieldNames) === null || _b === void 0 ? void 0 : _b.text) || 'text',
                options: 'items'
            }, value: selected, filterOption: false, onSearch: (value) => {
                if (props.loader && props.searchParamName) {
                    const params = {};
                    params[props.searchParamName] = value;
                    api.get(props.loader, { params })
                        .then((data) => {
                        setOptions(data.filter((item) => getTagValue(item) !== value));
                    });
                }
            }, onChange: (value) => {
                const tag = options.find((item) => getTagValue(item) === value);
                if (tag) {
                    setTags([tag, ...tags]);
                }
                setSelected('');
                setOptions([]);
                props.onChange && props.onChange([...(props.value || []), value]);
            } }),
        React.createElement(List, { size: 'small', split: false, dataSource: props.value || [], renderItem: (val) => {
                const item = (tags || []).find((item) => getTagValue(item) === val);
                return item
                    ? (React.createElement(List.Item, null,
                        React.createElement(Tag, { closable: true, onClose: () => {
                                props.onChange && props
                                    .onChange((props.value || [])
                                    .filter((value) => getTagValue(item) !== value));
                            } },
                            React.createElement(Text, { style: { width: '100%' } }, getTagText(item)))))
                    : (React.createElement(React.Fragment, null));
            } })));
}
